import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import styles from './Count.module.scss'

export default function Count({ count, isLoading, toggleVisibility }) {
  const [windowSize, setWindowSize] = useState(0)

  const getInflection = () => {
    if (count === 0) {
      return 'kohdetta'
    }

    if (count > 1) {
      return 'kohdetta'
    }

    return 'kohde'
  }

  const getWindowSize = () => {
    const { innerWidth } = window
    return innerWidth
  }

  const handleWindowResize = () => {
    setWindowSize(getWindowSize())
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)
    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  useEffect(() => {
    handleWindowResize()
  }, [])

  return (
    <section>
      <div className="container">
        <div className={styles.headingRow}>
          {isLoading && <h1 className={styles.title}>Etsitään...</h1>}
          {!isLoading && (
            <h1 className={styles.title}>
              <span className={styles.count}>
                {count} {getInflection()}
              </span>{' '}
              vastaa hakuasi!
            </h1>
          )}
          <button
            className={`btn btn--secondary btn--pink ${styles.icon}`}
            onClick={toggleVisibility}
          >
            <div className={styles.buttonElement}>
              <Image
                src="/img/setting.svg"
                width="24"
                height="24"
                objectFit="fill"
              />
              {windowSize > 768 && (
                <span className={styles.buttonText}>Suodata hakutuloksia</span>
              )}
            </div>
          </button>
        </div>
      </div>
    </section>
  )
}
